import styled from "styled-components";
import { FaCalendarAlt, FaMapMarker } from "react-icons/fa";

export const CardContainer = styled.div`
  position: relative;
  margin-top: 2rem;
  background: #fff;
  transition: box-shadow 0.2s cubic-bezier(0.37, 0.75, 0.61, 1.05);
  flex: 1 ${(props) => props.flexBasis || 16}%;
  margin: 0.5rem;
  box-shadow: 0 2px 16px rgba(30, 60, 114, 0.1);
  border-radius: 16px;
  border: none;
  overflow: hidden;
  min-height: 340px;
  &:hover {
    box-shadow: 0 8px 32px rgba(30, 60, 114, 0.16);
    transform: translateY(-2px) scale(1.01);
  }
  @media (max-width: 56.25em) {
    width: 100%;
    margin: 1rem 0.5rem;
    flex: 1 100%;
  }
`;

export const CardMedia = styled.a`
  position: relative;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
  }
`;

export const CardImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

export const CardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px 0 16px 0;
  color: #222;
  background-color: #f8fafc;
  border: none;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
`;

export const CardWrapper = styled.div`
  margin: 0 1.2rem;
`;

export const CardHeading = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
`;

export const CardPrimaryTitle = styled.h2`
  font-family: "Roboto", Arial, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  color: #1e3c72;
  margin-bottom: 2px;
  @media (max-width: 56.25em) {
    font-size: 18px;
  }
`;

export const CardSecondaryTitle = styled.h4`
  font-family: "Roboto", Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #2ca58d;
  margin-bottom: 2px;
  @media (max-width: 56.25em) {
    font-size: 15px;
  }
`;

export const CardMeta = styled.div`
  margin: 12px 0 8px 0;
`;

export const CardMetaText = styled.p`
  color: #2ca58d;
  font-size: 15px;
  display: inline-block;
  font-family: "Roboto", Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  margin: 0;
`;

export const CardDateIcon = styled(FaCalendarAlt)`
  font-size: 1.2rem;
  margin-right: 10px;
  margin-bottom: 0.1rem;
  color: #2a5298;
  transition: all 0.2s ease-in-out;
`;

export const CardLocation = styled.div`
  cursor: pointer;
  color: #39364f;
  display: flex;
  align-items: center;
  margin-top: 1.1rem;
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    margin-left: 0.5rem;
  }
`;

export const CardLocationIcon = styled(FaMapMarker)`
  font-size: 1.2rem;
  margin-right: 10px;
  margin-bottom: 0.1rem;
  color: #2a5298;
  transition: all 0.2s ease-in-out;
`;

export const CardText = styled.div`
  font-family: "Roboto", Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7c859b;
  margin-bottom: 18px;
`;

export const CardCTA = styled.div`
  padding: 12px 0 0 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
`;

export const CardButton = styled.a`
  font-family: "Roboto", Arial, sans-serif;
  font-style: ${({ fontWeight }) => (fontWeight ? "bold" : "normal")};
  text-transform: ${({ uppercase }) => (uppercase ? "uppercase" : "normal")};
  line-height: 26px;
  background: #2a5298;
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  font-weight: ${({ fontWeight }) => (fontWeight ? "700" : "500")};
  font-size: ${({ fontBig }) => (fontBig ? "22px" : "16px")};
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  text-align: center;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(30, 60, 114, 0.08);
  &:hover {
    background: #284c87;
    color: #fff;
    box-shadow: 0 4px 16px rgba(30, 60, 114, 0.12);
  }
`;
